import React from 'react';
import { withAuthDomain } from '../../components/Session';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import withWidth from '@material-ui/core/withWidth';
import {Grid, Paper, Typography } from '@material-ui/core';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import StarIcon from '@material-ui/icons/StarBorder';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Divider from '@material-ui/core/Divider';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import FolderIcon from '@material-ui/icons/Folder';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles(theme => ({
  root: {
    overscrollBehavior: "contain",
    maxWidth:"100vw",
    minHeight:"89vh",
    overflow:"auto",
    margin:"0px",
    padding:"0px",
    paddingBottom:"70px",
    position:"relative",
    userSelect:"none", 
  },
  paper:{
    margin:"10px",
    padding:"20px",
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
}));

const CompanySettingsPage = (props) => {
  const {
    firebase,
    currentUser,
    companyView,
    branchView,
    employeeData,
    sessionDomain,
    domainExpirationStatus,
    featureStatus,
    errorPosition,
    
    width,
    currentDate,
    serverMillis,
    serverClockStatus,
    activeCompany,
    
    //...otherProps
  }=props
  const classes = useStyles();
  const [pricingOpen,setPricingOpen]=React.useState(false)

  const [editCompanyInformation,setEditCompanyInformation]=React.useState(false)
  const [savingCompanyInformation,setSavingCompanyInformation]=React.useState(false)
  const [editCompanyBrand,setEditCompanyBrand]=React.useState(false)
  const [savingCompanyBrand,setSavingCompanyBrand]=React.useState(false)
  const [editCompanyStandard,setEditCompanyStandard]=React.useState(false)
  const [savingCompanyStandard,setSavingCompanyStandard]=React.useState(false)
  
  //const [newCompanyType,setNewCompanyType]=React.useState("")
  
  React.useEffect(()=>{
    var dcompanyType=document.getElementById("companyType")
    if(!!dcompanyType)dcompanyType.value=activeCompany.type||""
    revertCompanyInformation()
    revertCompanyBrand()
    revertCompanyStandard()
  },[activeCompany])
  
  function saveCompanyInformation(){
    if(!activeCompany)return
    var dcompanyName,dcompanyAddress,dcompanyTown,dcompanyPhone,dcompanyEmail,dcompanyNPWP
    var companyName,companyAddress,companyTown,companyPhone,companyEmail,companyNPWP
    
    dcompanyName=document.getElementById("companyName")
    dcompanyAddress=document.getElementById("companyAddress")
    dcompanyTown=document.getElementById("companyTown")
    dcompanyPhone=document.getElementById("companyPhone")
    dcompanyEmail=document.getElementById("companyEmail")
    dcompanyNPWP=document.getElementById("companyNPWP")

    companyName=dcompanyName.value
    companyAddress=dcompanyAddress.value
    companyTown=dcompanyTown.value
    companyPhone=dcompanyPhone.value
    companyEmail=dcompanyEmail.value
    companyNPWP=dcompanyNPWP.value
    //console.log(companyName+" | "+companyAddress+" | "+companyTown+" | "+companyPhone+" | "+companyEmail+" | "+companyNPWP)
    if(!companyName ||!companyAddress ||!companyTown ||!companyPhone ||!companyEmail){
      alert("Mohon lengkapi data")
      return
    }
    
    var companyObj={
      name:companyName,
      address:companyAddress,
      town:companyTown,
      phone:companyPhone,
      email:companyEmail,
      NPWP:companyNPWP,
    }
    setSavingCompanyInformation(true)
    firebase.fs.collection("companies").doc(activeCompany.id).set(
      companyObj,{merge:true}
    ).then(()=>{
      setSavingCompanyInformation(false)
      setEditCompanyInformation(false)
    }).catch(e=>{
      alert("Gagal menyimpan perusahaan : "+e)
      setSavingCompanyInformation(false)
    })
  }

  function revertCompanyInformation(){
    if(!!activeCompany){
      var dcompanyName,dcompanyAddress,dcompanyTown,dcompanyPhone,dcompanyEmail,dcompanyNPWP
      
      dcompanyName=document.getElementById("companyName")
      dcompanyAddress=document.getElementById("companyAddress")
      dcompanyTown=document.getElementById("companyTown")
      dcompanyPhone=document.getElementById("companyPhone")
      dcompanyEmail=document.getElementById("companyEmail")
      dcompanyNPWP=document.getElementById("companyNPWP")

      if(!!dcompanyName)dcompanyName.value=activeCompany.name||""
      if(!!dcompanyAddress)dcompanyAddress.value=activeCompany.address||""
      if(!!dcompanyTown)dcompanyTown.value=activeCompany.town||""
      if(!!dcompanyPhone)dcompanyPhone.value=activeCompany.phone||""
      if(!!dcompanyEmail)dcompanyEmail.value=activeCompany.email||""
      if(!!dcompanyNPWP)dcompanyNPWP.value=activeCompany.NPWP||""
    }
    setEditCompanyInformation(false)
  }

  function saveCompanyBrand(){
    if(!activeCompany)return
    var dlogoURL,dbrandColorPrimary,dbrandColorSecondary
    var logoURL,brandColorPrimary,brandColorSecondary
    
    dlogoURL=document.getElementById("logoURL")
    dbrandColorPrimary=document.getElementById("brandColorPrimary")
    dbrandColorSecondary=document.getElementById("brandColorSecondary")

    logoURL=dlogoURL.value
    brandColorPrimary=dbrandColorPrimary.value
    brandColorSecondary=dbrandColorSecondary.value
    
    var companyObj={
      logoURL:logoURL,
      brandColorPrimary:brandColorPrimary,
      brandColorSecondary:brandColorSecondary,
    }
    setSavingCompanyBrand(true)
    firebase.fs.collection("companies").doc(activeCompany.id).set(
      companyObj,{merge:true}
    ).then(()=>{
      setSavingCompanyBrand(false)
      setEditCompanyBrand(false)
    }).catch(e=>{
      alert("Gagal menyimpan perusahaan : "+e)
      setSavingCompanyBrand(false)
    })
  }

  function revertCompanyBrand(){
    if(!!activeCompany){
      var dlogoURL,dbrandColorPrimary,dbrandColorSecondary
      
      dlogoURL=document.getElementById("logoURL")
      dbrandColorPrimary=document.getElementById("brandColorPrimary")
      dbrandColorSecondary=document.getElementById("brandColorSecondary")

      if(!!dlogoURL)dlogoURL.value=activeCompany.logoURL||""
      if(!!dbrandColorPrimary)dbrandColorPrimary.value=activeCompany.brandColorPrimary||""
      if(!!dbrandColorSecondary)dbrandColorSecondary.value=activeCompany.brandColorSecondary||""
    }
    setEditCompanyBrand(false)
  }

  function saveCompanyStandard(){
    if(!activeCompany)return
    var dcurrency,dprefixIdCustomer,dprefixIdSupplier,dprefixIdReseller,dprefixIdProduct
    var currency,prefixIdCustomer,prefixIdSupplier,prefixIdReseller,prefixIdProduct
    
    dcurrency=document.getElementById("currency")
    dprefixIdCustomer=document.getElementById("prefixIdCustomer")
    dprefixIdSupplier=document.getElementById("prefixIdSupplier")
    dprefixIdReseller=document.getElementById("prefixIdReseller")
    dprefixIdProduct=document.getElementById("prefixIdProduct")

    currency=!!dcurrency?dcurrency.value:""
    prefixIdCustomer=!!dprefixIdCustomer?dprefixIdCustomer.value:""
    prefixIdSupplier=!!dprefixIdSupplier?dprefixIdSupplier.value:""
    prefixIdReseller=!!dprefixIdReseller?dprefixIdReseller.value:""
    prefixIdProduct=!!dprefixIdProduct?dprefixIdProduct.value:""

    if(!currency){
      currency="62"
    }
    
    var companyObj={}
    switch(activeCompany.type){
      case "Finance":
        companyObj={
          currency:currency,
          prefixIdCustomer:prefixIdCustomer,
          prefixIdSupplier:prefixIdSupplier,
          prefixIdReseller:prefixIdReseller,
          prefixIdProduct:prefixIdProduct,
        }
        break
    }
    
    setSavingCompanyStandard(true)
    firebase.fs.collection("companies").doc(activeCompany.id).set(
      companyObj,{merge:true}
    ).then(()=>{
      setSavingCompanyStandard(false)
      setEditCompanyStandard(false)
    }).catch(e=>{
      alert("Gagal menyimpan perusahaan : "+e)
      setSavingCompanyStandard(false)
    })
  }

  function revertCompanyStandard(){
    if(!!activeCompany){
      var dcurrency,dprefixIdCustomer,dprefixIdSupplier,dprefixIdReseller,dprefixIdProduct

      dcurrency=document.getElementById("currency")
      dprefixIdCustomer=document.getElementById("prefixIdCustomer")
      dprefixIdSupplier=document.getElementById("prefixIdSupplier")
      dprefixIdReseller=document.getElementById("prefixIdReseller")
      dprefixIdProduct=document.getElementById("prefixIdProduct")

      if(!!dcurrency)dcurrency.value=activeCompany.currency||"62"
      if(!!dprefixIdCustomer)dprefixIdCustomer.value=activeCompany.prefixIdCustomer||""
      if(!!dprefixIdSupplier)dprefixIdSupplier.value=activeCompany.prefixIdSupplier||""
      if(!!dprefixIdReseller)dprefixIdReseller.value=activeCompany.prefixIdReseller||""
      if(!!dprefixIdProduct)dprefixIdProduct.value=activeCompany.prefixIdProduct||""
    }
    setEditCompanyStandard(false)
  }

  function toogleCompanyEnabled(company){
    var pr=""
    if(!company.deactivated){
      pr=window.prompt("Apakah Anda yakin untuk menon-aktifkan "+company.name+"?\n\nMasukkan '"+company.name+"' untuk melanjutkan.")
      if(!pr){
        return
      }else if(pr!==company.name){
        alert("Kode tidak sesuai")
        return
      }
    }

    firebase.fs.doc("companies/"+company.id).set({
      deactivated:!company.deactivated
    },{merge:true}).then().catch(e=>{
      alert("Gagal : "+e)
    })
  }

  return (
    <div className={classes.root}>
      {sessionDomain>=1&&!!activeCompany&&
        <Grid container direction={width==="xs"?"column":"row"} justify={width==="xs"?"center":"flex-start"} alignItems={width==="xs"?"stretch":"flex-start"}>
          <Grid item xs={12} style={{margin:width==="xs"?"10px":"0px"}}>
            <Paper elevation={3} className={classes.paper} style={{minHeight:"300px",width:width==="xs"?"95%":"98%%"}}>
              <Typography variant="h5">
                Informasi Perusahaan{width==="xs"?<br/>:null}
                <Button style={{float:"right"}} variant="contained" color={editCompanyInformation?"secondary":"primary"} disabled={savingCompanyInformation} onClick={editCompanyInformation?()=>saveCompanyInformation():()=>setEditCompanyInformation(true)} >{editCompanyInformation?"Simpan":"Ubah"}</Button>
                {editCompanyInformation&&<Button style={{float:"right",marginRight:"5px"}} variant="outlined" color="primary" disabled={savingCompanyInformation} onClick={revertCompanyInformation} >Batal</Button>}
              </Typography>
              <TextField
                id="companyType"
                label="Tipe Usaha"
                placeholder=""
                required
                disabled={!editCompanyInformation}
                fullWidth={true}
                style={{margin:"5px"}}
                defaultValue={activeCompany.type}
                disabled={true}
              />
              <TextField
                id="companyName"
                label="Nama Cabang"
                placeholder=""
                required
                disabled={!editCompanyInformation}
                fullWidth={true}
                defaultValue={activeCompany.name}
                style={{margin:"5px"}}
              />
              <TextField
                id="companyAddress"
                label="Alamat"
                placeholder=""
                required
                disabled={!editCompanyInformation}
                fullWidth={true}
                defaultValue={activeCompany.address}
                style={{margin:"5px"}}
              />
              <TextField
                id="companyTown"
                label="Kota"
                placeholder=""
                required
                disabled={!editCompanyInformation}
                fullWidth={true}
                defaultValue={activeCompany.town}
                style={{margin:"5px"}}
              />
              <TextField
                id="companyPhone"
                label="Nomor Telepon"
                placeholder=""
                required
                disabled={!editCompanyInformation}
                fullWidth={true}
                defaultValue={activeCompany.phone}
                style={{margin:"5px"}}
              />
              <TextField
                id="companyEmail"
                label="Email"
                placeholder=""
                required
                disabled={!editCompanyInformation}
                fullWidth={true}
                defaultValue={activeCompany.email}
                style={{margin:"5px"}}
              />
              <TextField
                id="companyNPWP"
                label="NPWP"
                placeholder=""
                disabled={!editCompanyInformation}
                fullWidth={true}
                defaultValue={activeCompany.NPWP}
                style={{margin:"5px"}}
              />  
            </Paper>
          </Grid>
          
          <Grid item xs={12} style={{margin:width==="xs"?"10px":"0px"}}>
            <Paper elevation={3} className={classes.paper} style={{minHeight:"300px",width:width==="xs"?"95%":"98%%"}}>
              <Typography variant="h5">
                Brand Perusahaan{width==="xs"?<br/>:null}
                <Button style={{float:"right"}} variant="contained" color={editCompanyBrand?"secondary":"primary"} disabled={savingCompanyBrand} onClick={editCompanyBrand?()=>saveCompanyBrand():()=>setEditCompanyBrand(true)} >{editCompanyBrand?"Simpan":"Ubah"}</Button>
                {editCompanyBrand&&<Button style={{float:"right",marginRight:"5px"}} variant="outlined" color="primary" disabled={savingCompanyBrand} onClick={revertCompanyBrand} >Batal</Button>}
              </Typography>
              <TextField
                id="logoURL"
                label="Logo Brand"
                placeholder=""
                disabled={!editCompanyBrand}
                fullWidth={true}
                defaultValue={activeCompany.logoURL}
                style={{margin:"5px"}}
              />
              <TextField
                id="brandColorPrimary"
                label="Warna Utama"
                placeholder=""
                disabled={!editCompanyBrand}
                fullWidth={true}
                defaultValue={activeCompany.brandColorPrimary}
                style={{margin:"5px"}}
              />
              <TextField
                id="brandColorSecondary"
                label="Warna Utama"
                placeholder=""
                disabled={!editCompanyBrand}
                fullWidth={true}
                defaultValue={activeCompany.brandColorSecondary}
                style={{margin:"5px"}}
              />
              
              
            </Paper>
          </Grid>

          <Grid item xs={12} style={{margin:width==="xs"?"10px":"0px"}}>
            <Paper elevation={3} className={classes.paper} style={{minHeight:"300px",width:width==="xs"?"95%":"98%%"}}>
              <Typography variant="h5">
                Standard Perusahaan{width==="xs"?<br/>:null}
                {(activeCompany.type==="Finance"
                //||activeCompany.type==="Workshop"||activeCompany.type==="Production"||activeCompany.type==="Market"||activeCompany.type==="Restaurant"
                )&&
                <>
                  <Button style={{float:"right"}} variant="contained" color={editCompanyStandard?"secondary":"primary"} disabled={savingCompanyStandard} onClick={editCompanyStandard?()=>saveCompanyStandard():()=>setEditCompanyStandard(true)} >{editCompanyStandard?"Simpan":"Ubah"}</Button>
                  {editCompanyStandard&&<Button style={{float:"right",marginRight:"5px"}} variant="outlined" color="primary" disabled={savingCompanyStandard} onClick={revertCompanyStandard} >Batal</Button>}
                </>}
                
              </Typography>
              {(activeCompany.type!=="Finance"
              //||activeCompany.type!=="Workshop"||activeCompany.type!=="Production"||activeCompany.type!=="Market"||activeCompany.type!=="Restaurant"
              )&&<Typography variant="subtitle1">Tidak ada pengaturan standard</Typography>}

              {activeCompany.type==="Finance"&&
              <>
                <TextField
                  id="currency"
                  label="Mata Uang"
                  placeholder=""
                  disabled={!editCompanyStandard}
                  fullWidth={true}
                  defaultValue={activeCompany.currency}
                  style={{margin:"5px"}}
                />
                <TextField
                  id="prefixIdCustomer"
                  label="ID Customer"
                  placeholder=""
                  disabled={!editCompanyStandard}
                  fullWidth={true}
                  defaultValue={activeCompany.prefixIdCustomer}
                  style={{margin:"5px"}}
                />
                <TextField
                  id="prefixIdSupplier"
                  label="ID Supplier"
                  placeholder=""
                  disabled={!editCompanyStandard}
                  fullWidth={true}
                  defaultValue={activeCompany.prefixIdSupplier}
                  style={{margin:"5px"}}
                />
                <TextField
                  id="prefixIdReseller"
                  label="ID Reseller"
                  placeholder=""
                  disabled={!editCompanyStandard}
                  fullWidth={true}
                  defaultValue={activeCompany.prefixIdReseller}
                  style={{margin:"5px"}}
                />
                <TextField
                  id="prefixIdProduct"
                  label="ID Product"
                  placeholder=""
                  disabled={!editCompanyStandard}
                  fullWidth={true}
                  defaultValue={activeCompany.prefixIdProduct}
                  style={{margin:"5px"}}
                />
              </>
              }
            </Paper>
          </Grid>

          <Grid item xs={12} style={{margin:width==="xs"?"10px":"0px"}}>
            <Paper elevation={3} className={classes.paper} style={{minHeight:"100px",width:width==="xs"?"95%":"98%%"}}>
              <Typography variant="h5">
                Deaktivasi
                <IconButton
                  edge="end"
                  aria-label="delete"
                  style={{float:"right"}}
                  color={activeCompany.deactivated?"default":"primary"}
                  onClick={()=>toogleCompanyEnabled(activeCompany)}>
                  {activeCompany.deactivated?<NotInterestedIcon />:<PowerSettingsNewIcon/>}
                </IconButton>
              </Typography>
              <Typography variant="subtitle1">
                Status Perusahaan : {activeCompany.deactivated?"NON AKTIF":"AKTIF"}
              </Typography>
              
            </Paper>
          </Grid>

          
        </Grid>
      }
    </div>
  )
}

const condition = authUser => !!authUser;
export default withAuthDomain(condition,false,"online-asset-manager","")(withWidth()(CompanySettingsPage));